import React from 'react';
import PropTypes from 'prop-types';

const Logout = ({ theme, fill, ...props }) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M14.445 14.5275H9.70499C9.60327 14.5274 9.50258 14.548 9.40905 14.588C9.31552 14.628 9.23111 14.6866 9.16095 14.7603C9.0908 14.8339 9.03636 14.9211 9.00095 15.0165C8.96554 15.1118 8.94991 15.2134 8.95499 15.315C8.95467 15.5183 9.03222 15.714 9.17172 15.8618C9.31121 16.0097 9.50204 16.0985 9.70499 16.11H14.445C14.8641 16.108 15.2655 15.9407 15.5618 15.6443C15.8582 15.348 16.0255 14.9466 16.0275 14.5275V3.47251C16.0255 3.05342 15.8582 2.65205 15.5618 2.3557C15.2655 2.05935 14.8641 1.89199 14.445 1.89001H9.70499C9.50204 1.90152 9.31121 1.99033 9.17172 2.13819C9.03222 2.28606 8.95467 2.48174 8.95499 2.68501C8.95499 2.88393 9.03401 3.07469 9.17466 3.21535C9.31532 3.356 9.50608 3.43501 9.70499 3.43501H14.445V14.5275Z"
      fill={fill || theme.GLOBAL_SIDEBAR.secondaryBtn}
    />
    <path
      d="M2.085 9.2775L4.29 11.4825C4.34516 11.5392 4.416 11.5782 4.49344 11.5944C4.57089 11.6107 4.65142 11.6034 4.72472 11.5736C4.79802 11.5438 4.86076 11.4928 4.9049 11.4272C4.94904 11.3615 4.97258 11.2841 4.9725 11.205V9.7875H10.5C10.6048 9.79288 10.7096 9.7762 10.8076 9.73853C10.9056 9.70086 10.9946 9.64304 11.0688 9.56882C11.143 9.49459 11.2009 9.4056 11.2385 9.30762C11.2762 9.20964 11.2929 9.10483 11.2875 9C11.2876 8.89827 11.2671 8.79758 11.227 8.70405C11.187 8.61052 11.1284 8.52611 11.0547 8.45596C10.9811 8.3858 10.8939 8.33136 10.7985 8.29595C10.7032 8.26055 10.6016 8.24491 10.5 8.25H4.9725V6.795C4.97113 6.71741 4.94707 6.64192 4.90331 6.57785C4.85954 6.51377 4.79798 6.4639 4.72621 6.4344C4.65444 6.40489 4.5756 6.39704 4.49942 6.4118C4.42324 6.42657 4.35305 6.46331 4.2975 6.5175L2.0925 8.7225C2.05527 8.75828 2.02552 8.80109 2.00496 8.84846C1.98441 8.89582 1.97347 8.9468 1.97277 8.99843C1.97207 9.05006 1.98163 9.10131 2.0009 9.14922C2.02016 9.19712 2.04875 9.24073 2.085 9.2775Z"
      fill={fill || theme.GLOBAL_SIDEBAR.secondaryBtn}
    />
  </svg>
);

Logout.propTypes = {
  fill: PropTypes.string,
  theme: PropTypes.object,
};

export default Logout;
